const LocalStorageCacheKey = {
  LAST_USED_PROJECT: 'last-used-project',
  REFERENCE_DATE: 'reference-date',
};

export { LocalStorageCacheKey };
